import { render, staticRenderFns } from "./TencentAd.vue?vue&type=template&id=d263c4be&scoped=true"
import script from "./TencentAd.vue?vue&type=script&lang=js"
export * from "./TencentAd.vue?vue&type=script&lang=js"
import style0 from "./TencentAd.vue?vue&type=style&index=0&id=d263c4be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d263c4be",
  null
  
)

export default component.exports